import script from "./LongInsureDispatchDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./LongInsureDispatchDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./LongInsureDispatchDrawer.vue?vue&type=style&index=0&id=417605ad&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-417605ad"]])

export default __exports__